import ItemAddForm from './item-add-form';

export default ItemAddForm;



// WEBPACK FOOTER //
// ./src/components/item-add-form/index.js